<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-card elevation="0" color="#E7F2F8">
                    <v-card-title class="text-h6">
                        {{ timeofday }}, {{ getname }}!
                    </v-card-title>
                    <v-card-subtitle style="color: black;">Today is: {{ getTodaysDate }}</v-card-subtitle>
                    <v-card-text>
                        <v-icon>mdi-alert-box</v-icon>&nbsp;Features you see in this portal may vary with your permission settings.
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-card elevation="0">
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="7">
                        <MyBookmark />
                    </v-col>
                    <v-col cols="12" sm="5">
                        <DeadlineCard />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import DeadlineCard from "../../../components/Admin/Home/DeadlineCard.vue"
import MyBookmark from "../../../components/Admin/Home/Bookmark.vue"

import auth from "../../../js/auth"

export default {
    components: {
        DeadlineCard,
        MyBookmark
    },
    computed: {
        getTodaysDate(){
            let date = new Date();
            return date.toDateString()
        },
        getname(){
            let user = auth.get_user();
            return user ["commonname"]
        }
    },
    data(){
        return {
            timeofday: "Good morning!"
        }
    },
    methods: {
        getTimeOftheDay(){
            const that = this;
            let date = new Date();
            let hour = date.getHours();

            if (hour >= 12 && hour < 18) {
                that.timeofday = "Good afternoon";
            } else if (hour >= 18 && hour < 24) {
                that.timeofday = "Good evening"
            }else {
                that.timeofday = "Good morning"
            }
        }
    },
    created(){
        const that = this;
        that.getTimeOftheDay();
    }
}
</script>